export const MissionStatus = {
    validated: "validated",
    submitted: "submitted",
    rejected: "rejected"
}
